const getFormData = (object) =>
  Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key] || "");
    return formData;
  }, new FormData());
export default getFormData;
